import api from "api";

const eventAnalytics = {
    // Público, sem auth — força isPublic=true pra nunca anexar Authorization,
    // mesmo se o visitante estiver logado (ex: produtor vendo o próprio evento).
    track: (eventId, type, sessionId) => {
        return api(false, true).post(`/events/${eventId}/track`, {
            type,
            session_id: sessionId,
        });
    },

    // Autenticado, só o dono do evento — api() padrão já anexa o Bearer token.
    getAnalytics: (eventId) => {
        return api().get(`/events/${eventId}/analytics`);
    },
}

export default eventAnalytics;
